class CartError {
    public error: number = 0;
    public message: string = "";
}

export default CartError;
